import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';

interface Props {
  autoComplete?: string;
  className?: string;
  id?: string;
  placeholder?: string;
  readOnly?: boolean;
  type?: string;
  value?: string;
  onBlur?: (event: any) => any;
  onChange?: (event: any) => any;
  onFocus?: (event: any) => any;
}

const PasswordInput = (props: Props) => {
  const [showPassowrd, setShowPassword] = useState(true);

  return (
    <div className="form-password-input">
      <input
        className="form-control"
        autoComplete="off"
        {...props}
        type={showPassowrd ? 'password' : 'text'}
      />
      <span onClick={() => setShowPassword(!showPassowrd)} className="form-icon">
        {showPassowrd ? (
          <FontAwesomeIcon icon={faEye} className="text-custom-control-checked" />
        ) : (
          <FontAwesomeIcon icon={faEyeSlash} className="text-danger" />
        )}
      </span>
    </div>
  );
};

export default PasswordInput;
